export const MISC_PAGES = [
  {
    slug: "faq",
    fr: {
      eyebrow: "FAQ",
      title: "Questions fréquentes",
      intro:
        "Des réponses claires sur nos services, notre processus, nos honoraires et notre cadre — avant même de nous rencontrer.",
      chips: [],
      sections: [
        {
          type: "faq",
          theme: "light",
          title: "Général",
          items: [
            { q: "Que fait Columbus Management Consulting GmbH ?", a: "Nous conseillons investisseurs privés, entreprises et institutions sur l'investissement immobilier, la structuration de patrimoine, les transactions et la conformité transfrontalière — entre Suisse et les marchés internationaux." },
            { q: "Qui sont vos clients types ?", a: "Des particuliers fortunés, des familles, des entrepreneurs, des family offices et des institutions — pour des mandats allant de l'acquisition d'un actif unique à la restructuration patrimoniale complète." },
            { q: "Où êtes-vous établis ?", a: "Société suisse immatriculée à Zurich (CH-020.4.044.478-1). Nous intervenons sur de nombreuses juridictions via notre réseau de partenaires." },
          ],
        },
        {
          type: "faq",
          theme: "dark",
          title: "Services & processus",
          items: [
            { q: "Quel est le périmètre typique d'un mandat ?", a: "Chaque mandat est scopé individuellement : diagnostic écrit, stratégie chiffrée, exécution coordonnée et suivi annuel. Aucune mission ne commence sans périmètre validé." },
            { q: "Proposez-vous des accompagnements au forfait annuel ?", a: "Oui. Des conventions de conseil continu existent pour les clients qui souhaitent un conseiller senior disponible en permanence, avec revue annuelle et alertes." },
            { q: "Comment démarre un engagement ?", a: "Par une première conversation confidentielle et sans engagement. Nous cadrons ensuite par écrit le périmètre, les livrables et les honoraires avant tout travail." },
            { q: "Sous quel délai répondez-vous ?", a: "Réponse initiale sous 24 h ouvrées, appel de découverte sous 3 jours ouvrés, proposition sous 5 à 10 jours ouvrés." },
            { q: "Le premier rendez-vous est-il payant ?", a: "Non. Le premier rendez-vous est gratuit, confidentiel et sans engagement — à nos bureaux ou en visioconférence." },
          ],
        },
        {
          type: "faq",
          theme: "light",
          title: "Honoraires & indépendance",
          items: [
            { q: "Comment êtes-vous rémunérés ?", a: "Par des honoraires de mandat transparents, écrits et validés avant toute mission — généralement entre 4 % et 12 % selon la nature de l'investissement. Aucune rétrocession cachée." },
            { q: "Quel est le ticket d'investissement minimum ?", a: "Nos mandats démarrent généralement à partir de 1 M CHF/EUR. En dessous, nous vous orientons honnêtement vers la solution la plus adaptée — même si elle n'est pas chez nous." },
            { q: "Êtes-vous vraiment indépendants ?", a: "Oui. Société détenue par ses associés, sans lien capitalistique avec des banques, promoteurs ou plateformes de distribution." },
            { q: "Exigez-vous l'exclusivité ?", a: "Non, sauf sur les missions d'exécution transactionnelle où l'exclusivité protège votre position de négociation. Nous l'expliquons alors avant signature." },
          ],
        },
        {
          type: "faq",
          theme: "dark",
          title: "Confidentialité & données",
          items: [
            { q: "Comment gérez-vous la confidentialité ?", a: "Accès contrôlé, documentation sécurisée, échanges chiffrés. Aucune information, structure ou stratégie n'est jamais référencée sans autorisation explicite." },
            { q: "Mes données sont-elles protégées ?", a: "Oui : conformité nLPD suisse et RGPD européen, conservation minimale, et utilisation limitée au traitement de votre demande." },
          ],
        },
      ],
    },
    en: {
      eyebrow: "FAQ",
      title: "Frequently asked questions",
      intro: "Clear answers on our services, process, fees and framework — before we even meet.",
      chips: [],
      sections: [
        {
          type: "faq",
          theme: "light",
          title: "General",
          items: [
            { q: "What does Columbus Management Consulting GmbH do?", a: "We advise private investors, companies and institutions on real estate investment, wealth structuring, transactions and cross-border compliance — across Switzerland and international markets." },
            { q: "Who are your typical clients?", a: "High-net-worth individuals, families, entrepreneurs, family offices and institutions — for mandates ranging from single-asset acquisition to full wealth restructuring." },
            { q: "Where are you based?", a: "A Swiss company registered in Zurich (CH-020.4.044.478-1). We operate across many jurisdictions through our partner network." },
          ],
        },
        {
          type: "faq",
          theme: "dark",
          title: "Services & process",
          items: [
            { q: "What is the typical scope of an engagement?", a: "Every mandate is individually scoped: written diagnosis, quantified strategy, coordinated execution and annual review. No work begins without a validated scope." },
            { q: "Do you offer ongoing retainer arrangements?", a: "Yes. Continuous advisory agreements exist for clients who want a senior advisor permanently available, with annual reviews and alerts." },
            { q: "How does an engagement begin?", a: "With a first confidential, no-obligation conversation. We then frame scope, deliverables and fees in writing before any work." },
            { q: "How quickly do you respond?", a: "Initial reply within one business day, discovery call within 3 business days, proposal within 5–10 business days." },
            { q: "Is the first meeting charged?", a: "No. The first meeting is free, confidential and without obligation — at our offices or by video call." },
          ],
        },
        {
          type: "faq",
          theme: "light",
          title: "Fees & independence",
          items: [
            { q: "How are you compensated?", a: "Through transparent mandate fees, written and approved before any engagement — typically between 4% and 12% depending on the nature of the investment. No hidden retrocessions." },
            { q: "What is the minimum investment ticket?", a: "Our mandates typically start at CHF/EUR 1 million. Below that, we honestly point you to the most suitable solution — even if it is not with us." },
            { q: "Are you truly independent?", a: "Yes. A company owned by its partners, with no equity ties to banks, developers or distribution platforms." },
            { q: "Do you require exclusivity?", a: "No, except on transactional execution mandates where exclusivity protects your negotiating position. We explain this before signing." },
          ],
        },
        {
          type: "faq",
          theme: "dark",
          title: "Confidentiality & data",
          items: [
            { q: "How do you handle confidentiality?", a: "Controlled access, secure documentation, encrypted exchanges. No information, structure or strategy is ever referenced without explicit authorisation." },
            { q: "Is my data protected?", a: "Yes: Swiss nFADP and European GDPR compliance, minimal retention, and use limited to processing your request." },
          ],
        },
      ],
    },
    de: {
      eyebrow: "FAQ",
      title: "Häufige Fragen",
      intro: "Klare Antworten zu unseren Dienstleistungen, unserem Prozess, unseren Honoraren und unserem Rahmen — noch vor dem ersten Treffen.",
      chips: [],
      sections: [
        {
          type: "faq",
          theme: "light",
          title: "Allgemein",
          items: [
            { q: "Was macht die Columbus Management Consulting GmbH?", a: "Wir beraten Privatinvestoren, Unternehmen und Institutionen zu Immobilieninvestitionen, Vermögensstrukturierung, Transaktionen und grenzüberschreitender Compliance — in der Schweiz und auf internationalen Märkten." },
            { q: "Wer sind Ihre typischen Kunden?", a: "Vermögende Privatpersonen, Familien, Unternehmer, Family Offices und Institutionen — für Mandate vom Erwerb eines einzelnen Objekts bis zur vollständigen Vermögensrestrukturierung." },
            { q: "Wo sind Sie ansässig?", a: "Eine Schweizer Gesellschaft mit Sitz in Zürich, Kanton Zürich (CH-020.4.044.478-1). Über unser Partnernetzwerk sind wir in vielen Jurisdiktionen tätig." },
          ],
        },
        {
          type: "faq",
          theme: "dark",
          title: "Leistungen & Prozess",
          items: [
            { q: "Wie sieht der typische Umfang eines Mandats aus?", a: "Jedes Mandat wird individuell abgegrenzt: schriftliche Diagnose, bezifferte Strategie, koordinierte Ausführung und jährliches Review. Keine Arbeit beginnt ohne validierten Umfang." },
            { q: "Bieten Sie laufende Jahresmandate an?", a: "Ja. Für Kunden, die einen permanent verfügbaren Senior-Berater wünschen, gibt es Rahmenverträge mit jährlichem Review und Warnmeldungen." },
            { q: "Wie beginnt eine Zusammenarbeit?", a: "Mit einem ersten vertraulichen, unverbindlichen Gespräch. Umfang, Lieferobjekte und Honorare halten wir anschliessend schriftlich fest, bevor irgendetwas beginnt." },
            { q: "Wie schnell antworten Sie?", a: "Erste Antwort innerhalb eines Arbeitstages, Kennenlerngespräch innerhalb von 3 Arbeitstagen, Angebot innerhalb von 5–10 Arbeitstagen." },
            { q: "Ist das erste Gespräch kostenpflichtig?", a: "Nein. Das erste Gespräch ist kostenlos, vertraulich und unverbindlich — bei uns vor Ort oder per Video." },
          ],
        },
        {
          type: "faq",
          theme: "light",
          title: "Honorare & Unabhängigkeit",
          items: [
            { q: "Wie werden Sie vergütet?", a: "Durch transparente Mandatshonorare, schriftlich festgehalten und vor jeder Aufgabe genehmigt — in der Regel zwischen 4 % und 12 %, je nach Art der Investition. Keine versteckten Retrozessionen." },
            { q: "Wie hoch ist das minimale Anlageticket?", a: "Unsere Mandate beginnen in der Regel ab 1 Mio. CHF/EUR. Darunter verweisen wir Sie ehrlich auf die passendste Lösung — auch wenn sie nicht bei uns liegt." },
            { q: "Sind Sie wirklich unabhängig?", a: "Ja. Eine Gesellschaft im Besitz ihrer Partner, ohne Beteiligungsverflechtungen mit Banken, Entwicklern oder Vertriebsplattformen." },
            { q: "Verlangen Sie Exklusivität?", a: "Nein, ausser bei transaktionalen Ausführungsmandaten, wo Exklusivität Ihre Verhandlungsposition schützt. Das erklären wir vor der Unterschrift." },
          ],
        },
        {
          type: "faq",
          theme: "dark",
          title: "Vertraulichkeit & Daten",
          items: [
            { q: "Wie handhaben Sie Vertraulichkeit?", a: "Kontrollierter Zugriff, gesicherte Dokumentation, verschlüsselte Übermittlung. Keine Information, Struktur oder Strategie wird je ohne ausdrückliche Genehmigung referenziert." },
            { q: "Sind meine Daten geschützt?", a: "Ja: Konformität mit Schweizer nDSG und europäischer DSGVO, minimale Aufbewahrung und Nutzung ausschliesslich zur Bearbeitung Ihrer Anfrage." },
          ],
        },
      ],
    },
  },
  {
    slug: "confidentialite",
    fr: {
      eyebrow: "Légal",
      title: "Politique de confidentialité",
      intro: "Comment Columbus Management Consulting GmbH collecte, utilise et protège vos données personnelles.",
      chips: ["nLPD", "RGPD"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Responsable du traitement",
          paragraphs: [
            "Columbus Management Consulting GmbH, Susenbergstrasse 104, 8044 Zürich, Suisse — contact@columbusmanagementconsulting.com. Nous traitons vos données conformément à la loi suisse sur la protection des données (nLPD) et, le cas échéant, au RGPD européen.",
          ],
        },
        {
          type: "text",
          theme: "dark",
          title: "Données collectées et finalité",
          paragraphs: [
            "Via le formulaire de contact : nom, email, téléphone, profil investisseur et message. Ces données servent exclusivement à répondre à votre demande et, si vous le devenez, à gérer la relation client.",
            "Nous ne vendons ni ne partageons vos données avec des tiers à des fins commerciales. Les sous-traitants techniques éventuels sont liés par des obligations de confidentialité.",
          ],
        },
        {
          type: "text",
          theme: "light",
          title: "Conservation et droits",
          paragraphs: [
            "Les demandes non suivies d'une relation sont conservées au maximum 12 mois. Vous disposez d'un droit d'accès, de rectification et de suppression : écrivez à contact@columbusmanagementconsulting.com.",
            "Dernière mise à jour : octobre 2026.",
          ],
        },
      ],
    },
    en: {
      eyebrow: "Legal",
      title: "Privacy policy",
      intro: "How Columbus Management Consulting GmbH collects, uses and protects your personal data.",
      chips: ["nFADP", "GDPR"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Data controller",
          paragraphs: [
            "Columbus Management Consulting GmbH, Susenbergstrasse 104, 8044 Zürich, Switzerland — contact@columbusmanagementconsulting.com. We process your data in accordance with the Swiss Federal Act on Data Protection (nFADP) and, where applicable, the European GDPR.",
          ],
        },
        {
          type: "text",
          theme: "dark",
          title: "Data collected and purpose",
          paragraphs: [
            "Via the contact form: name, email, phone, investor profile and message. This data is used exclusively to respond to your enquiry and, if you become one, to manage the client relationship.",
            "We do not sell or share your data with third parties for commercial purposes. Any technical processors are bound by confidentiality obligations.",
          ],
        },
        {
          type: "text",
          theme: "light",
          title: "Retention and rights",
          paragraphs: [
            "Enquiries that do not lead to a relationship are kept for a maximum of 12 months. You have the right to access, rectify and delete your data: write to contact@columbusmanagementconsulting.com.",
            "Last updated: October 2026.",
          ],
        },
      ],
    },
    de: {
      eyebrow: "Rechtliches",
      title: "Datenschutzerklärung",
      intro: "Wie die Columbus Management Consulting GmbH Ihre personenbezogenen Daten erhebt, verwendet und schützt.",
      chips: ["nDSG", "DSGVO"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Verantwortliche Stelle",
          paragraphs: [
            "Columbus Management Consulting GmbH, Susenbergstrasse 104, 8044 Zürich, Schweiz — contact@columbusmanagementconsulting.com. Wir bearbeiten Ihre Daten gemäss dem Schweizer Datenschutzgesetz (nDSG) und, soweit anwendbar, der europäischen DSGVO.",
          ],
        },
        {
          type: "text",
          theme: "dark",
          title: "Erhobene Daten und Zweck",
          paragraphs: [
            "Über das Kontaktformular: Name, E-Mail, Telefon, Investorenprofil und Nachricht. Diese Daten dienen ausschliesslich der Beantwortung Ihrer Anfrage und, falls Sie Kunde werden, der Pflege der Kundenbeziehung.",
            "Wir verkaufen Ihre Daten nicht und geben sie nicht zu kommerziellen Zwecken an Dritte weiter. Allfällige technische Auftragsbearbeiter sind an Vertraulichkeitspflichten gebunden.",
          ],
        },
        {
          type: "text",
          theme: "light",
          title: "Aufbewahrung und Rechte",
          paragraphs: [
            "Anfragen, die zu keiner Beziehung führen, werden maximal 12 Monate aufbewahrt. Sie haben das Recht auf Auskunft, Berichtigung und Löschung: Schreiben Sie an contact@columbusmanagementconsulting.com.",
            "Letzte Aktualisierung: Oktober 2026.",
          ],
        },
      ],
    },
  },
  {
    slug: "conditions",
    fr: {
      eyebrow: "Légal",
      title: "Conditions générales",
      intro: "Les conditions régissant l'utilisation de ce site et nos relations précontractuelles.",
      chips: [],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Utilisation du site",
          paragraphs: [
            "Le contenu de ce site est fourni à titre informatif général. Il ne constitue ni un conseil en investissement, ni une offre, ni une sollicitation d'achat ou de vente d'instruments financiers ou immobiliers.",
            "Toute relation de conseil fait l'objet d'un mandat écrit et signé, définissant périmètre, honoraires et responsabilités.",
          ],
        },
        {
          type: "text",
          theme: "dark",
          title: "Responsabilité",
          paragraphs: [
            "Nous apportons le plus grand soin à l'exactitude des informations publiées, sans pouvoir la garantir. Les chiffres de performance présentés sont indicatifs et ne constituent pas des résultats vérifiés ou une promesse de rendement.",
            "Le droit suisse est applicable. For juridique : Zurich, Suisse.",
          ],
        },
      ],
    },
    en: {
      eyebrow: "Legal",
      title: "Terms & conditions",
      intro: "The terms governing the use of this site and our pre-contractual relations.",
      chips: [],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Use of the site",
          paragraphs: [
            "The content of this site is provided for general information only. It constitutes neither investment advice nor an offer or solicitation to buy or sell financial or real estate instruments.",
            "Any advisory relationship is governed by a written, signed mandate defining scope, fees and responsibilities.",
          ],
        },
        {
          type: "text",
          theme: "dark",
          title: "Liability",
          paragraphs: [
            "We take the greatest care with the accuracy of published information, without being able to guarantee it. Performance figures shown are indicative and constitute neither verified results nor a promise of return.",
            "Swiss law applies. Jurisdiction: Zurich, Switzerland.",
          ],
        },
      ],
    },
    de: {
      eyebrow: "Rechtliches",
      title: "Allgemeine Geschäftsbedingungen",
      intro: "Die Bedingungen für die Nutzung dieser Website und unsere vorvertraglichen Beziehungen.",
      chips: [],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Nutzung der Website",
          paragraphs: [
            "Der Inhalt dieser Website dient der allgemeinen Information. Er stellt weder eine Anlageberatung noch ein Angebot oder eine Aufforderung zum Kauf oder Verkauf von Finanz- oder Immobilieninstrumenten dar.",
            "Jede Beratungsbeziehung wird durch ein schriftliches, unterzeichnetes Mandat geregelt, das Umfang, Honorare und Verantwortlichkeiten definiert.",
          ],
        },
        {
          type: "text",
          theme: "dark",
          title: "Haftung",
          paragraphs: [
            "Wir wenden grösste Sorgfalt auf die Richtigkeit der veröffentlichten Informationen an, ohne sie garantieren zu können. Dargestellte Performance-Zahlen sind indikativ und stellen weder geprüfte Ergebnisse noch ein Renditeversprechen dar.",
            "Es gilt Schweizer Recht. Gerichtsstand: Zürich, Schweiz.",
          ],
        },
      ],
    },
  },
  {
    slug: "mentions-reglementaires",
    fr: {
      eyebrow: "Légal",
      title: "Mentions réglementaires",
      intro: "Informations d'identification et cadre d'activité de Columbus Management Consulting GmbH.",
      chips: ["CHE-486.721.940"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Identification",
          paragraphs: [
            "Columbus Management Consulting GmbH — société à responsabilité limitée de droit suisse. Registre du commerce du canton de Zurich : CH-020.4.044.478-1 · Inscription : 01.03.2011 · IDE/TVA : CHE-486.721.940. Siège : Susenbergstrasse 104, 8044 Zürich, Suisse. Direction : Thomas Peter Ruppelt, CEO.",
          ],
        },
        {
          type: "text",
          theme: "dark",
          title: "Cadre d'activité",
          paragraphs: [
            "Columbus Management Consulting GmbH exerce une activité de conseil en investissement et de structuration. Nous ne sommes ni une banque, ni un gestionnaire de fortune soumis à autorisation FINMA, ni un dépositaire.",
            "Nous ne remplaçons pas les conseils juridiques ou fiscaux qualifiés : nous coordonnons les spécialistes agréés lorsque la réglementation l'exige. Nos activités respectent les obligations AML/KYC applicables, avec vérification complète de chaque client avant toute relation.",
          ],
        },
      ],
    },
    en: {
      eyebrow: "Legal",
      title: "Regulatory disclosures",
      intro: "Identification information and activity framework of Columbus Management Consulting GmbH.",
      chips: ["CHE-486.721.940"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Identification",
          paragraphs: [
            "Columbus Management Consulting GmbH — limited liability company under Swiss law. Commercial register of the canton of Zurich: CH-020.4.044.478-1 · Registered: 01.03.2011 · VAT/UID: CHE-486.721.940. Registered office: Susenbergstrasse 104, 8044 Zürich, Switzerland. Management: Thomas Peter Ruppelt, CEO.",
          ],
        },
        {
          type: "text",
          theme: "dark",
          title: "Activity framework",
          paragraphs: [
            "Columbus Management Consulting GmbH carries out investment advisory and structuring activities. We are neither a bank, nor a wealth manager subject to FINMA authorisation, nor a custodian.",
            "We do not replace qualified legal or tax counsel: we coordinate licensed specialists where regulation requires. Our activities comply with applicable AML/KYC obligations, with full verification of every client before any relationship.",
          ],
        },
      ],
    },
    de: {
      eyebrow: "Rechtliches",
      title: "Regulatorische Hinweise",
      intro: "Identifikationsdaten und Tätigkeitsrahmen der Columbus Management Consulting GmbH.",
      chips: ["CHE-486.721.940"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Identifikation",
          paragraphs: [
            "Columbus Management Consulting GmbH — Gesellschaft mit beschränkter Haftung nach Schweizer Recht. Handelsregister des Kantons Zürich: CH-020.4.044.478-1 · Eintragung: 01.03.2011 · IDE/MWST: CHE-486.721.940. Sitz: Susenbergstrasse 104, 8044 Zürich, Schweiz. Geschäftsführung: Thomas Peter Ruppelt, CEO.",
          ],
        },
        {
          type: "text",
          theme: "dark",
          title: "Tätigkeitsrahmen",
          paragraphs: [
            "Die Columbus Management Consulting GmbH übt eine Anlageberatungs- und Strukturierungstätigkeit aus. Wir sind weder eine Bank noch ein FINMA-bewilligter Vermögensverwalter noch eine Verwahrstelle.",
            "Wir ersetzen keine qualifizierten Rechts- oder Steuerberater: Wir koordinieren zugelassene Spezialisten, wo die Regulierung es verlangt. Unsere Tätigkeiten erfüllen die geltenden AML/KYC-Pflichten, mit vollständiger Prüfung jedes Kunden vor jeder Beziehung.",
          ],
        },
      ],
    },
  },
  {
    slug: "cookies",
    fr: {
      eyebrow: "Légal",
      title: "Politique cookies",
      intro: "Une utilisation minimale et transparente des technologies de stockage.",
      chips: [],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Ce que nous utilisons",
          paragraphs: [
            "Ce site utilise uniquement le stockage local du navigateur pour mémoriser vos préférences essentielles (choix de langue) et peut charger des ressources de polices externes.",
            "Aucun cookie publicitaire, aucun pistage tiers à des fins marketing n'est mis en place par nos soins.",
          ],
        },
        {
          type: "text",
          theme: "dark",
          title: "Vos choix",
          paragraphs: [
            "Vous pouvez supprimer ces préférences à tout moment via les paramètres de votre navigateur, sans impact sur l'accès au contenu du site.",
          ],
        },
      ],
    },
    en: {
      eyebrow: "Legal",
      title: "Cookie policy",
      intro: "A minimal and transparent use of storage technologies.",
      chips: [],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "What we use",
          paragraphs: [
            "This site only uses browser local storage to remember your essential preferences (language choice) and may load external font resources.",
            "No advertising cookies, no third-party marketing tracking is implemented by us.",
          ],
        },
        {
          type: "text",
          theme: "dark",
          title: "Your choices",
          paragraphs: [
            "You can delete these preferences at any time via your browser settings, without affecting access to the site's content.",
          ],
        },
      ],
    },
    de: {
      eyebrow: "Rechtliches",
      title: "Cookie-Richtlinie",
      intro: "Ein minimaler und transparenter Einsatz von Speichertechnologien.",
      chips: [],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Was wir verwenden",
          paragraphs: [
            "Diese Website verwendet ausschliesslich den lokalen Browser-Speicher, um Ihre wesentlichen Präferenzen (Sprachwahl) zu merken, und kann externe Schriftressourcen laden.",
            "Wir setzen keine Werbe-Cookies und kein Marketing-Tracking durch Dritte ein.",
          ],
        },
        {
          type: "text",
          theme: "dark",
          title: "Ihre Wahl",
          paragraphs: [
            "Sie können diese Präferenzen jederzeit über Ihre Browser-Einstellungen löschen, ohne dass der Zugang zum Inhalt der Website beeinträchtigt wird.",
          ],
        },
      ],
    },
  },
];
